import { Box, Export, TextBlock, Upload } from "@bcc-ui/ui-components";
import classNames from "classnames";
import * as React from "react";
import { FileDrop } from "react-file-drop";
import { useTranslation } from "react-i18next";

import { ButtonContainer } from "components/button-container/ButtonContainer";
import style from "components/import-file-dialog/import-file-dialog.scss";
import buttons from "styles/buttons.scss";
import { resolveColor } from "utils/commonFunctions";

import testIds from "testIds.json";

interface Props {
    introductionMessage?: string;
    handleFileDrop: (fileList: FileList, event: React.DragEvent<HTMLDivElement>) => void;
    onFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSelectFileClicked: () => void;
    fileInputRef: React.RefObject<HTMLInputElement>;
    multiple?: boolean;
    showGoBackButton?: boolean;
    handleGoBack?: () => void;
    licenseKeysUpload?: boolean;
    onDownloadFileClicked?: () => void;
}

const SelectingView = (props: Props) => {
    const { t } = useTranslation();

    return (
        <>
            <Box
                columnLayout
                marginTop="Md"
                gap="Md"
                data-testid={testIds.common.importFileDialog.dragDropArea}
                className={style.selectFileWrapper}
            >
                {props.introductionMessage && (
                    <div className={style.introductionLabel}>{props.introductionMessage}</div>
                )}
                <FileDrop onDrop={props.handleFileDrop}>
                    <Upload color={resolveColor("--theme-primary")} />
                    <Box columnLayout verticalAlignment="Center" className={style.boldenedText}>
                        <TextBlock alignCenter disableBottomSpacing>
                            {t("Settings.selectFile.dragDropMessage")}
                        </TextBlock>
                        <TextBlock alignCenter disableBottomSpacing>
                            {t("Common.lowerCaseOr")}
                        </TextBlock>
                        <input
                            data-testid={testIds.common.importFileDialog.fileNameInput}
                            onChange={props.onFileInputChange}
                            ref={props.fileInputRef}
                            type="file"
                            multiple={props.multiple}
                            className={style.hidden}
                        />
                        <button type="button" onClick={props.onSelectFileClicked} className={style.selectFile}>
                            {t("Settings.selectFile.browseFiles")}
                        </button>
                    </Box>
                </FileDrop>
                {props.licenseKeysUpload ? (
                    <Box columnLayout gap="Xs">
                        {t("ImportOemSerialLicenseKeys.selectFile.sampleCsvFileMessage")}
                        <div
                            className={classNames(style.boldenedText, style.sampleCsvFileWrapper)}
                            onClick={props.onDownloadFileClicked}
                            data-testid={testIds.common.importFileDialog.sampleFileDownloadButton}
                        >
                            {t("ImportOemSerialLicenseKeys.selectFile.sampleCsvFileName")}
                            <Export color={resolveColor("--theme-primary")} />
                        </div>
                    </Box>
                ) : null}
            </Box>
            {props.showGoBackButton === true && (
                <ButtonContainer>
                    <button
                        type="button"
                        className={classNames(buttons.primaryButtonWithoutIcon, style.button)}
                        data-testid={testIds.common.importFileDialog.uploadAnotherButton}
                        onClick={() => {
                            if (!props.handleGoBack) {
                                return;
                            }
                            props.handleGoBack();
                        }}
                    >
                        {t("Common.goBack")}
                    </button>
                </ButtonContainer>
            )}
        </>
    );
};

export default SelectingView;
